import { createRoot } from 'react-dom/client'

import { AppProvider } from 'AppContext'
import AppRoutes from 'AppRoutes'
import { SongProvider } from 'SongContext'
import { translations } from 'locales'
import Settings from 'settings'
import { setupSettings } from 'utils/settings'
import { i18n } from 'utils/translation'

import registerServiceWorker from './service-worker-registration'

// Set up the global settings
setupSettings(Settings)

// Initialize the translation system
i18n(translations, Settings.uiLanguages, Settings.defaultUILanguage)

const container = document.getElementById('root')

if (import.meta.env.PROD) {
  registerServiceWorker(() => {
    console.info('Service Worker Registered')
  })
}

if (container) {
  const root = createRoot(container)
  root.render(
    <AppProvider>
      <SongProvider>
        <AppRoutes />
      </SongProvider>
    </AppProvider>,
  )
}
